import script from "./Teacher.vue?vue&type=script&setup=true&lang=js"
export * from "./Teacher.vue?vue&type=script&setup=true&lang=js"

import "./Teacher.vue?vue&type=style&index=0&id=5ef5e0c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef5e0c1"]])

export default __exports__